import { useTranslation } from "react-i18next";
import {
	Biometric,
	BiometricMealState,
	BiometricType,
} from "../../models/entities/biometrics.model";
import { BiometricsFormatter } from "../../services/biometrics/biometrics-formatter.service";
import { Formatter } from "../../services/formatter/formatter.service";
import { getBrowserLang } from "../../services/i18n/i18n.service";
import { classNames } from "primereact/utils";

const TrackHealthList = ({ type, data }: { type: BiometricType; data: Biometric[] }) => {
	const { t } = useTranslation("common");

	return (
		<div className="track-health-list">
			<div className="track-health-list__title">{t("TRACK_HEALTH.LIST_TITLE")}</div>
			<div className="track-health-list__content">
				{data.map((x) => (
					<div
						key={x.vitalTime}
						className="grid"
					>
						{/* Date */}
						<div
							className={classNames(
								"track-health-list__content__date",
								type !== BiometricType.glucose
									? "col-4 sm:col-3 md:col-2 lg:col-3 xl:col-2"
									: "col-4 sm:col-3 md:col-2 lg:col-3 xl:col-2"
							)}
						>
							{Formatter.date(x.vitalTime, {
								day: "2-digit",
								month: "2-digit",
								year: "2-digit",
							})}
						</div>

						{/* Hour */}
						<div
							className={classNames(
								type !== BiometricType.glucose
									? "col-4 sm:col-3 md:col-2 lg:col-3 xl:col-2"
									: "col-4 sm:col-3 md:col-2 lg:col-3 xl:col-2"
							)}
						>
							{new Intl.DateTimeFormat(getBrowserLang(), {
								hour: "2-digit",
								minute: "2-digit",
								hour12: true,
							}).format(new Date(x.vitalTime))}
						</div>

						{/* Value */}
						<div
							className={classNames(
								type !== BiometricType.weight
									? "col-4 sm:col-3 md:col-2 lg:col-3 xl:col-3"
									: "col-4 sm:col-6 md:col-8 lg:col-6 xl:col-4"
							)}
						>
							{BiometricsFormatter.formatByType(type, x)}
						</div>

						{/* Heart rate (blood pressure only) */}
						{x.type === BiometricType.blood_pressure && (
							<div className="col-6 sm:col-3 md:col-4 lg:col-3 xl:col-3">
								{BiometricsFormatter.formatHeartRate(x)}
							</div>
						)}

						{/* Meal state (glucose only) */}
						{x.type === BiometricType.glucose && (
							<div className="col-6 sm:col-3 md:col-4 lg:col-3 xl:col-3">
								{!x.mealState || x.mealState === BiometricMealState.UNKNOWN
									? Formatter.NO_DATA
									: t(`ENUMS.MEAL_STATE.${x.mealState}`)}
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};
export default TrackHealthList;
